import type { ConceptDef } from '../types';

export const sortByCategory: ConceptDef = {
  kind: 'tileMatch',
  id: 'sort-by-category',
  label: 'Sort by Category',
  category: 'Sorting',
  description: 'Hear a category; tap an item that belongs to it.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'an animal', answer: '🐶 dog' },
      { say: 'a fruit', answer: '🍎 apple' },
      { say: 'a vehicle', answer: '🚗 car' },
      { say: 'a tool', answer: '🔨 hammer' },
      { say: 'a piece of clothing', answer: '👕 shirt' },
      { say: 'a drink', answer: '🥛 milk' },
    ],
  },
};
